import { SVGProps } from "react";

const Indonesia = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#F8F9F9"
      />
      <path
        d="M2 12C2 6.47719 6.47719 2 12 2C17.5228 2 22 6.47719 22 12"
        fill="#A2001D"
      />
    </svg>
  );
};

export default Indonesia;
